<template>
  <div id="">
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true">
        <el-form-item>
          <el-input v-model="appid" placeholder="appid"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="secret" placeholder="secret"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="body" rows="5" type="textarea" placeholder="body"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="el-form-button" type="primary" v-on:click="getSign">获取</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true">
        <el-form-item>
          <el-input v-model="newBody" rows="5" type="textarea" placeholder="newBody"></el-input>
        </el-form-item>
      </el-form>
    </el-col>
  </div>
</template>

<script>
import {HttpResp} from '../../constant/index';
import {dslApi} from '../../api/index';
import PageGroup from "../template/PageGroup";

export default {
  name: 'DslOpenApiSign',
  components: {PageGroup},
  data() {
    return {
      appid: '',
      secret: '',
      body: '',
      newBody: ''
    }
  },
  mounted: function () {
  },
  computed: {

  },
  methods: {
    getSign() {
      dslApi.openApiSign(this.body, this.appid, this.secret).then(data => {
        if(data.code == HttpResp.SUCCUSS){
          this.newBody = JSON.stringify(data.data);
        }else{
          this.$message({
            type: 'error',
            message: data.message
          });
        }
      });
    },
  }

}
</script>



// WEBPACK FOOTER //
// src/components/dsl/DslOpenApiSign.vue